import React from 'react'

type iconType =
  | 'camera'
  | 'course_text'
  | 'course_video'
  | 'course_past_exam_analysis'
  | 'course_video_timeline'
  | 'course_quiz'
  | 'arrow_left'
  | 'arrow_right'
  | 'arrow_down'
  | 'x'
  | 'nodata'
  | 'closeicon'
  | 'seemore'
  | 'search'
  | 'input_calendar'
  | 'calendar_check'
  | 'calendar_busy'
  | 'start_outline'
  | 'book_open'
  | 'plus'
  | 'locksection'
  | 'calendar'
  | 'arrowUp'
  | 'arrowDown'
  | 'arrowDownFull'
  | 'arrowRightFull'
  | 'warningIcon'
  | 'calendarStudent'

type SAPP_ICONS_TYPE = {
  [key in iconType]: React.ReactNode
}

type Props = {
  icon: keyof SAPP_ICONS_TYPE
  className?: string
}

const SappIcon = ({ icon, className }: Props) => {
  const SAPP_ICONS: SAPP_ICONS_TYPE = {
    camera: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        className={className}
      >
        <g fill="#A1A1A1" clipPath="url(#a)">
          <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6ZM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2Z" />
          <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z" />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    ),
    course_text: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        className={className}
      >
        <rect
          width={15}
          height={15}
          x={0.5}
          y={0.5}
          stroke="#A1A1A1"
          rx={1.5}
        />
        <path
          fill="#A1A1A1"
          d="M3.333 4.2c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 6.533c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 8.867c0-.11.09-.2.2-.2h8.934c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6ZM3.333 11.2c0-.11.09-.2.2-.2H9.8c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H3.533a.2.2 0 0 1-.2-.2v-.6Z"
        />
      </svg>
    ),
    course_video: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        className={className}
      >
        <rect
          width={15}
          height={15}
          x={0.5}
          y={0.5}
          stroke="#A1A1A1"
          rx={1.5}
        />
        <path
          stroke="#A1A1A1"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 10.403V5.466a.469.469 0 0 1 .709-.4l4.228 2.457a.468.468 0 0 1 0 .812L6.71 10.803a.469.469 0 0 1-.709-.4Z"
        />
      </svg>
    ),
    course_quiz: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
      >
        <path
          fill="#A1A1A1"
          stroke="#A1A1A1"
          strokeWidth={0.1}
          d="M7.202 9.69c.005-.49.062-.884.173-1.18a1.79 1.79 0 0 1 .473-.72 3.74 3.74 0 0 1 .723-.5c.164-.09.31-.195.44-.317.13-.123.23-.264.304-.424.076-.16.115-.335.115-.53 0-.24-.063-.447-.187-.621a1.225 1.225 0 0 0-.503-.408 1.684 1.684 0 0 0-.706-.145c-.226 0-.444.043-.653.127-.207.083-.38.214-.52.393a1.12 1.12 0 0 0-.2.437c-.04.17-.183.313-.368.313h-.477c-.198 0-.366-.169-.329-.373.057-.308.172-.582.347-.82A2.25 2.25 0 0 1 6.76 4.2a3.175 3.175 0 0 1 1.274-.249c.505 0 .946.09 1.323.273.378.182.672.432.879.752.21.32.314.683.314 1.09 0 .286-.05.547-.148.78a1.9 1.9 0 0 1-.42.624M7.203 9.69l2.745-2.256M7.202 9.69c0 .053.043.096.096.096h.928a.096.096 0 0 0 .096-.096h-.05m-1.07 0h1.07m1.71-2.22-.035-.036m.036.035-.036-.035m.036.035c-.18.182-.396.343-.65.483m.614-.518a2.756 2.756 0 0 1-.637.474m.024.044-.024-.044m.024.044a2.55 2.55 0 0 0-.588.435c-.145.147-.25.322-.316.527a2.738 2.738 0 0 0-.108.777h-.05m1.062-1.74v.001l-.024-.044m0 0L8.272 9.69m-.07 2.262a.808.808 0 0 0 .295-.268.681.681 0 0 0-.127-.895.83.83 0 0 0-.574-.216.83.83 0 0 0-.573.216.681.681 0 0 0-.242.523c0 .204.082.379.242.523a.83.83 0 0 0 .573.215c.15 0 .285-.032.406-.098Z"
        />
        <rect
          width={15}
          height={15}
          x={0.5}
          y={0.5}
          stroke="#A1A1A1"
          rx={1.5}
        />
      </svg>
    ),
    course_past_exam_analysis: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect width="24" height="24" rx="3" fill="#F1F1F2" />
        <rect
          x="5.25"
          y="19"
          width="11"
          height="1.5"
          rx="0.3"
          transform="rotate(-90 5.25 19)"
          fill="#404041"
        />
        <rect
          x="11.25"
          y="19"
          width="14"
          height="1.5"
          rx="0.3"
          transform="rotate(-90 11.25 19)"
          fill="#404041"
        />
        <rect
          x="17.25"
          y="19"
          width="9"
          height="1.5"
          rx="0.3"
          transform="rotate(-90 17.25 19)"
          fill="#404041"
        />
      </svg>
    ),
    course_video_timeline: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        fill="none"
      >
        <path
          className={className}
          d="M17.438 4.219H.563v1.687h16.875V4.22ZM14.625 8.156H3.375v1.688h11.25V8.156ZM11.25 12.094h-4.5v1.687h4.5v-1.687Z"
        />
      </svg>
    ),
    arrow_left: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        className={className}
      >
        <path
          fill="#404041"
          d="M11.313 3.411V2.203a.125.125 0 0 0-.202-.098L4.067 7.606a.498.498 0 0 0 0 .786l7.044 5.502a.124.124 0 0 0 .201-.099v-1.207a.253.253 0 0 0-.095-.197L5.592 8l5.625-4.392a.253.253 0 0 0 .095-.197Z"
        />
      </svg>
    ),
    arrow_right: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        className={className}
      >
        <path
          fill="#404041"
          d="M4.688 12.59v1.207c0 .105.12.162.201.098l7.044-5.501a.497.497 0 0 0 0-.786L4.889 2.106a.124.124 0 0 0-.201.099v1.207c0 .077.035.15.095.197L10.408 8l-5.625 4.392a.253.253 0 0 0-.095.197Z"
        />
      </svg>
    ),
    arrow_down: (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M4 9L9.5 14L15 9H4Z" />
      </svg>
    ),
    x: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className={className + ' fill-gray-1'}
      >
        <path d="M13.41 12L17 8.44003C17.191 8.24642 17.2972 7.98489 17.2953 7.71296C17.2934 7.44103 17.1836 7.18099 16.99 6.99003C16.7964 6.79908 16.5349 6.69285 16.2629 6.69473C15.991 6.6966 15.731 6.80642 15.54 7.00003L12 10.59L8.46 7.07003C8.27263 6.88378 8.01918 6.77924 7.755 6.77924C7.49081 6.77924 7.23736 6.88378 7.05 7.07003C6.95627 7.16299 6.88187 7.2736 6.8311 7.39546C6.78034 7.51731 6.7542 7.64802 6.7542 7.78003C6.7542 7.91204 6.78034 8.04275 6.8311 8.16461C6.88187 8.28647 6.95627 8.39707 7.05 8.49003L10.59 12L7 15.56C6.80904 15.7536 6.70282 16.0152 6.70469 16.2871C6.70657 16.559 6.81639 16.8191 7.01 17.01C7.2036 17.201 7.46514 17.3072 7.73707 17.3053C8.00899 17.3035 8.26904 17.1936 8.46 17L12 13.41L15.54 16.93C15.7274 17.1163 15.9808 17.2208 16.245 17.2208C16.5092 17.2208 16.7626 17.1163 16.95 16.93C17.0437 16.8371 17.1181 16.7265 17.1689 16.6046C17.2197 16.4827 17.2458 16.352 17.2458 16.22C17.2458 16.088 17.2197 15.9573 17.1689 15.8355C17.1181 15.7136 17.0437 15.603 16.95 15.51L13.41 12Z" />
      </svg>
    ),
    nodata: (
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-fill--available"
      >
        <g clipPath="url(#clip0_9347_5425)">
          <path
            d="M12.9347 56.9559H57.0653C64.1791 56.9559 70 51.1634 70 44.0847C70 37.0081 64.1791 31.2156 57.0653 31.2156H56.0284C54.9981 26.8778 51.0891 23.6272 46.4122 23.6272C45.2769 23.6272 44.1262 23.8766 43.1747 24.1959C40.8887 17.7056 34.6938 13.0441 27.3919 13.0441C18.1475 13.0441 10.6509 20.5013 10.6509 29.7019C10.6509 30.2816 10.6816 30.8547 10.7384 31.4169C4.66375 32.4625 0 37.7519 0 44.0847C0 51.1656 5.82094 56.9559 12.9347 56.9559ZM10.9266 32.4931L11.9328 32.3203L11.8278 31.3031C11.7731 30.7694 11.7447 30.2291 11.7447 29.6997C11.7447 21.1181 18.7644 14.1356 27.3919 14.1356C34.02 14.1356 39.9481 18.3225 42.1422 24.5569L42.5009 25.5719L43.5225 25.2306C44.2203 24.9966 45.29 24.7188 46.4144 24.7188C50.505 24.7188 54.0203 27.4947 54.9653 31.4672L55.1644 32.3072H56.0284H57.0653C63.595 32.3072 68.9062 37.59 68.9062 44.0825C68.9062 50.5772 63.595 55.86 57.0653 55.86H12.9347C6.405 55.86 1.09375 50.5772 1.09375 44.0825C1.09375 38.3491 5.22812 33.4731 10.9266 32.4931Z"
            fill="#A1A1A1"
          />
          <path
            d="M20.1532 47.3725L28.5598 38.8282L36.9642 47.3725L37.7473 46.6047L29.3276 38.045L37.7473 29.4854L36.9642 28.7197L28.5598 37.2641L20.1532 28.7197L19.3701 29.4854L27.7898 38.045L19.3701 46.6047L20.1532 47.3725Z"
            fill="#A1A1A1"
          />
        </g>
        <defs>
          <clipPath id="clip0_9347_5425">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    closeicon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.21967 6.21967C6.51256 5.92678 6.98744 5.92678 7.28033 6.21967L17.7803 16.7197C18.0732 17.0126 18.0732 17.4874 17.7803 17.7803C17.4874 18.0732 17.0126 18.0732 16.7197 17.7803L6.21967 7.28033C5.92678 6.98744 5.92678 6.51256 6.21967 6.21967Z"
          fill={className ? 'currentColor' : '#21272A'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7803 6.21967C18.0732 6.51256 18.0732 6.98744 17.7803 7.28033L7.28033 17.7803C6.98744 18.0732 6.51256 18.0732 6.21967 17.7803C5.92678 17.4874 5.92678 17.0126 6.21967 16.7197L16.7197 6.21967C17.0126 5.92678 17.4874 5.92678 17.7803 6.21967Z"
          fill={className ? 'currentColor' : '#21272A'}
        />
      </svg>
    ),
    seemore: (
      <svg
        className="ms-2.5 group-hover:fill-primary"
        width="12"
        height="7"
        viewBox="0 0 12 7"
        fill="#3964EA" // Original color
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.78317 4.16666H0.666504V2.83333H8.78317L6.88319 0.933387L7.83319 5.34058e-05L11.3332 3.5L7.83311 7.00005L6.88311 6.06672L8.78317 4.16666Z"
          className="transition-all duration-300 ease-in-out group-hover:fill-primary" // Added hover class for fill
        />
      </svg>
    ),
    search: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M16.9269 17.0401L20.4 20.4001M19.28 11.4401C19.28 15.77 15.7699 19.2801 11.44 19.2801C7.11009 19.2801 3.60001 15.77 3.60001 11.4401C3.60001 7.11019 7.11009 3.6001 11.44 3.6001C15.7699 3.6001 19.28 7.11019 19.28 11.4401Z"
          strokeWidth="2"
          strokeLinecap="round"
          className="stroke-bw-14"
        />
      </svg>
    ),
    input_calendar: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.616 2.8582V1.61654C14.599 1.4749 14.5307 1.34441 14.4239 1.24974C14.3172 1.15508 14.1795 1.1028 14.0368 1.1028C13.8942 1.1028 13.7565 1.15508 13.6498 1.24974C13.543 1.34441 13.4747 1.4749 13.4577 1.61654V2.67487H13.191H10.741V1.61654C10.741 1.46183 10.6796 1.31345 10.5702 1.20406C10.4608 1.09466 10.3124 1.0332 10.1577 1.0332C10.003 1.0332 9.8546 1.09466 9.7452 1.20406C9.63581 1.31345 9.57435 1.46183 9.57435 1.61654V2.6582H6.80768H6.54102V1.61654C6.524 1.4749 6.45566 1.34441 6.34894 1.24974C6.24222 1.15508 6.10451 1.1028 5.96185 1.1028C5.81919 1.1028 5.68148 1.15508 5.57476 1.24974C5.46804 1.34441 5.3997 1.4749 5.38268 1.61654V2.8582C4.31239 3.16693 3.3713 3.81489 2.70101 4.70459C2.03073 5.59429 1.66752 6.67761 1.66602 7.79154V13.8249C1.67043 15.1893 2.21611 16.4962 3.18325 17.4586C4.15038 18.4211 5.45992 18.9604 6.82435 18.9582H13.2077C14.5663 18.9516 15.8673 18.4084 16.8273 17.4469C17.7872 16.4854 18.3283 15.1835 18.3327 13.8249V7.79154C18.3312 6.67761 17.968 5.59429 17.2977 4.70459C16.6274 3.81489 15.6863 3.16693 14.616 2.8582ZM5.38268 4.0832V4.7582C5.3997 4.89984 5.46804 5.03033 5.57476 5.125C5.68148 5.21966 5.81919 5.27194 5.96185 5.27194C6.10451 5.27194 6.24222 5.21966 6.34894 5.125C6.45566 5.03033 6.524 4.89984 6.54102 4.7582V3.84154C6.63268 3.84154 6.71602 3.84154 6.80768 3.84154H9.57435V4.7582C9.57435 4.91291 9.63581 5.06129 9.7452 5.17068C9.8546 5.28008 10.003 5.34154 10.1577 5.34154C10.3124 5.34154 10.4608 5.28008 10.5702 5.17068C10.6796 5.06129 10.741 4.91291 10.741 4.7582V3.81654H13.191C13.2827 3.81654 13.366 3.81654 13.4577 3.81654V4.7332C13.4747 4.87484 13.543 5.00533 13.6498 5.1C13.7565 5.19466 13.8942 5.24694 14.0368 5.24694C14.1795 5.24694 14.3172 5.19466 14.4239 5.1C14.5307 5.00533 14.599 4.87484 14.616 4.7332V4.0832C15.2709 4.33794 15.847 4.76105 16.2859 5.30977C16.7249 5.85849 17.0112 6.51336 17.116 7.2082H2.86602C2.9723 6.51152 3.26113 5.85539 3.70317 5.30651C4.1452 4.75763 4.72467 4.33556 5.38268 4.0832ZM13.191 17.7999H6.80768C5.75047 17.8021 4.73555 17.3848 3.98564 16.6396C3.23573 15.8944 2.81209 14.8821 2.80768 13.8249V8.3332H17.191V13.7915C17.1932 14.3178 17.0913 14.8394 16.8912 15.3261C16.691 15.8129 16.3966 16.2553 16.0249 16.6278C15.6531 17.0003 15.2113 17.2957 14.725 17.4968C14.2386 17.698 13.7173 17.801 13.191 17.7999ZM7.99102 11.5332C7.996 11.6776 7.95775 11.8201 7.88117 11.9426C7.80459 12.065 7.69318 12.1618 7.56122 12.2206C7.42926 12.2793 7.28277 12.2973 7.14053 12.2722C6.99828 12.2471 6.86678 12.1801 6.76287 12.0798C6.65896 11.9794 6.58738 11.8504 6.55732 11.7091C6.52726 11.5678 6.54008 11.4208 6.59415 11.2868C6.64821 11.1529 6.74104 11.0382 6.86075 10.9573C6.98046 10.8765 7.12158 10.8333 7.26602 10.8332C7.45404 10.8331 7.63476 10.906 7.77003 11.0366C7.9053 11.1672 7.98453 11.3453 7.99102 11.5332ZM10.7077 11.5332C10.7143 11.6805 10.6764 11.8264 10.5988 11.9519C10.5212 12.0773 10.4076 12.1764 10.2729 12.2363C10.1381 12.2962 9.98839 12.314 9.84331 12.2875C9.69823 12.261 9.56452 12.1914 9.45962 12.0877C9.35472 11.9841 9.28352 11.8512 9.2553 11.7064C9.22709 11.5617 9.24317 11.4118 9.30145 11.2763C9.35974 11.1409 9.45751 11.0261 9.58201 10.9471C9.70651 10.868 9.85195 10.8283 9.99935 10.8332C10.1845 10.8374 10.361 10.9122 10.4927 11.0423C10.6244 11.1725 10.7013 11.3481 10.7077 11.5332ZM13.441 11.5332C13.4443 11.6793 13.4039 11.823 13.325 11.9459C13.2461 12.0689 13.1323 12.1655 12.9981 12.2233C12.8639 12.2811 12.7156 12.2975 12.572 12.2705C12.4284 12.2434 12.2962 12.1741 12.1923 12.0714C12.0884 11.9687 12.0176 11.8373 11.9889 11.694C11.9601 11.5508 11.9748 11.4022 12.0311 11.2674C12.0874 11.1326 12.1826 11.0176 12.3047 10.9373C12.4267 10.857 12.5699 10.8149 12.716 10.8165C12.9069 10.8165 13.09 10.8918 13.2257 11.0259C13.3615 11.1601 13.4388 11.3424 13.441 11.5332ZM7.98268 14.2249C7.98159 14.319 7.96198 14.412 7.92495 14.4985C7.88793 14.585 7.83422 14.6634 7.7669 14.7292C7.69957 14.795 7.61995 14.8469 7.53258 14.8819C7.44521 14.9169 7.3518 14.9343 7.25768 14.9332C7.11595 14.9315 6.9779 14.8879 6.86097 14.8078C6.74405 14.7277 6.65351 14.6147 6.6008 14.4831C6.54809 14.3515 6.53557 14.2073 6.56484 14.0686C6.59411 13.9299 6.66385 13.803 6.76523 13.704C6.86661 13.6049 6.99509 13.5382 7.13442 13.5121C7.27375 13.4861 7.41767 13.5019 7.54798 13.5577C7.67829 13.6135 7.78914 13.7066 7.86652 13.8254C7.9439 13.9441 7.98432 14.0831 7.98268 14.2249ZM10.6993 14.2249C10.7027 14.3706 10.6625 14.514 10.5839 14.6367C10.5054 14.7595 10.3921 14.8561 10.2584 14.9141C10.1247 14.9722 9.97677 14.9891 9.83344 14.9628C9.69011 14.9364 9.55789 14.8679 9.45365 14.766C9.34942 14.6641 9.27791 14.5335 9.24823 14.3908C9.21856 14.2482 9.23208 14.0999 9.28706 13.9649C9.34204 13.8299 9.43599 13.7144 9.55692 13.633C9.67785 13.5517 9.82027 13.5082 9.96602 13.5082C10.0615 13.506 10.1565 13.5229 10.2454 13.5579C10.3343 13.5929 10.4153 13.6454 10.4836 13.7121C10.5519 13.7789 10.6062 13.8587 10.6432 13.9467C10.6803 14.0348 10.6994 14.1293 10.6993 14.2249ZM13.4327 14.2249C13.436 14.3706 13.3958 14.514 13.3173 14.6367C13.2387 14.7595 13.1254 14.8561 12.9917 14.9141C12.8581 14.9722 12.7101 14.9891 12.5668 14.9628C12.4234 14.9364 12.2912 14.8679 12.187 14.766C12.0828 14.6641 12.0112 14.5335 11.9816 14.3908C11.9519 14.2482 11.9654 14.0999 12.0204 13.9649C12.0754 13.8299 12.1693 13.7144 12.2903 13.633C12.4112 13.5517 12.5536 13.5082 12.6993 13.5082C12.7949 13.506 12.8898 13.5229 12.9787 13.5579C13.0676 13.5929 13.1486 13.6454 13.2169 13.7121C13.2852 13.7789 13.3395 13.8587 13.3766 13.9467C13.4136 14.0348 13.4327 14.1293 13.4327 14.2249Z"
          fill="#99A1B7"
        />
      </svg>
    ),
    calendar_check: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_504_27474)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25V3.5H12.5V2.25C12.5 1.83579 12.8358 1.5 13.25 1.5C13.6642 1.5 14 1.83579 14 2.25V3.5H16.25C17.7688 3.5 19 4.73122 19 6.25V9.25C19 9.66421 18.6642 10 18.25 10H2.5V16.75C2.5 17.4404 3.05964 18 3.75 18H8.75C9.16421 18 9.5 18.3358 9.5 18.75C9.5 19.1642 9.16421 19.5 8.75 19.5H3.75C2.23122 19.5 1 18.2688 1 16.75V6.25C1 4.73122 2.23122 3.5 3.75 3.5H6V2.25C6 1.83579 6.33579 1.5 6.75 1.5ZM6 5H3.75C3.05964 5 2.5 5.55964 2.5 6.25V8.5H17.5V6.25C17.5 5.55964 16.9404 5 16.25 5H14V5.75C14 6.16421 13.6642 6.5 13.25 6.5C12.8358 6.5 12.5 6.16421 12.5 5.75V5H7.5V5.75C7.5 6.16421 7.16421 6.5 6.75 6.5C6.33579 6.5 6 6.16421 6 5.75V5ZM19.765 13.7047C20.0661 13.9891 20.0797 14.4638 19.7953 14.765L15.5453 19.265C15.4014 19.4173 15.2005 19.5025 14.991 19.4999C14.7815 19.4974 14.5827 19.4074 14.4425 19.2517L12.1925 16.7517C11.9154 16.4438 11.9404 15.9696 12.2483 15.6925C12.5562 15.4154 13.0304 15.4404 13.3075 15.7483L15.0133 17.6436L18.7047 13.735C18.9891 13.4339 19.4638 13.4203 19.765 13.7047Z"
            className="fill-[#07AF17]"
          />
        </g>
        <defs>
          <clipPath id="clip0_504_27474">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    book_open: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.36051 4.11971C6.37671 3.95978 5.3735 3.95977 4.38969 4.11969C4.04645 4.17549 3.70164 4.2585 2.93716 4.44368C2.81469 4.47335 2.74354 4.49072 2.69032 4.50583C2.6569 4.51532 2.64293 4.52058 2.6395 4.52196C2.6395 4.52196 2.6395 4.52196 2.6395 4.52196C2.57147 4.55542 2.52252 4.61776 2.50609 4.69125C2.50556 4.69493 2.50375 4.7097 2.5024 4.74419C2.50024 4.79939 2.50011 4.87254 2.50011 4.99846V16.3196C2.50011 16.4083 2.50015 16.4626 2.50105 16.5033C2.50163 16.5294 2.50244 16.541 2.50265 16.5437C2.52153 16.6749 2.64055 16.7691 2.7739 16.7564C2.7766 16.7559 2.78803 16.754 2.81375 16.7484C2.85362 16.7397 2.90644 16.7269 2.99264 16.706L3.00819 16.7023C3.34117 16.6216 3.52697 16.5766 3.71304 16.5384C5.13954 16.2457 6.61067 16.2457 8.03717 16.5384C8.22321 16.5766 8.40898 16.6216 8.74185 16.7022L9.25011 16.8253V4.54958L8.81305 4.44371C8.04857 4.25852 7.70375 4.1755 7.36051 4.11971ZM10.7501 4.54959V16.8253L11.2582 16.7023C11.5912 16.6216 11.777 16.5766 11.963 16.5384C13.3895 16.2457 14.8607 16.2457 16.2872 16.5384C16.4732 16.5766 16.659 16.6216 16.992 16.7023L17.0076 16.706C17.0938 16.7269 17.1466 16.7397 17.1865 16.7484C17.2256 16.757 17.2317 16.757 17.2242 16.7562C17.3584 16.7701 17.4786 16.6756 17.4976 16.5437C17.4978 16.541 17.4986 16.5294 17.4992 16.5033C17.5001 16.4626 17.5001 16.4083 17.5001 16.3196V4.99852C17.5001 4.87258 17.5 4.79943 17.4978 4.74423C17.4965 4.70973 17.4947 4.69496 17.4941 4.69129C17.4777 4.61779 17.4287 4.55545 17.3607 4.522C17.3573 4.52062 17.3433 4.51536 17.3099 4.50587C17.2567 4.49075 17.1855 4.47338 17.063 4.44372C16.2985 4.25853 15.9537 4.17551 15.6104 4.11972C14.6267 3.95981 13.6235 3.95981 12.6398 4.11972C12.2965 4.17551 11.9517 4.25853 11.1872 4.44372L10.7501 4.54959ZM4.14902 2.63913C5.29223 2.45329 6.45799 2.4533 7.6012 2.63914C8.00774 2.70523 8.41052 2.80281 9.13225 2.97765L9.80168 3.13981C9.87479 3.15752 9.91513 3.16723 9.94602 3.17381C9.97272 3.17949 9.97804 3.17967 9.97581 3.17945C9.99197 3.18102 10.0082 3.18102 10.0244 3.17945C10.0222 3.17967 10.0275 3.17949 10.0542 3.17381C10.0851 3.16723 10.1254 3.15752 10.1985 3.13982L10.868 2.97765C11.5897 2.80281 11.9925 2.70524 12.3991 2.63915C13.5423 2.45333 14.708 2.45333 15.8511 2.63915C16.2577 2.70524 16.6605 2.80281 17.3822 2.97765L17.4162 2.98588C17.4319 2.98969 17.4478 2.9935 17.4637 2.99732C17.6482 3.0417 17.8425 3.08844 18.0149 3.17215C18.4972 3.4064 18.8457 3.84888 18.9599 4.37292C19.0008 4.5602 19.0005 4.76011 19.0002 4.94971C19.0001 4.96606 19.0001 4.98234 19.0001 4.99852V16.3196C19.0001 16.3317 19.0001 16.3438 19.0001 16.3559C19.0003 16.4884 19.0004 16.6238 18.9843 16.7426C18.8576 17.6797 18.0092 18.3457 17.0693 18.2482C16.9501 18.2358 16.8185 18.2038 16.6896 18.1724C16.6779 18.1696 16.6661 18.1667 16.6544 18.1639C16.3018 18.0784 16.1428 18.04 15.9857 18.0078C14.7581 17.7559 13.4921 17.7559 12.2645 18.0078C12.1074 18.04 11.9484 18.0784 11.5958 18.1639L10.5517 18.4168C10.5427 18.4189 10.5337 18.4211 10.5246 18.4233C10.4134 18.4504 10.2943 18.4794 10.1697 18.4915C10.0569 18.5025 9.9433 18.5025 9.83048 18.4915C9.70589 18.4794 9.5868 18.4504 9.47557 18.4233C9.4665 18.4211 9.45749 18.4189 9.44854 18.4168L8.40443 18.1639C8.05182 18.0784 7.89278 18.04 7.7357 18.0078C6.50811 17.7559 5.2421 17.7559 4.01452 18.0078C3.85743 18.04 3.6984 18.0784 3.34578 18.1639C3.33408 18.1667 3.32234 18.1696 3.31058 18.1724C3.18171 18.2038 3.05015 18.2358 2.93091 18.2482C1.991 18.3457 1.14259 17.6797 1.01588 16.7426C0.999808 16.6238 0.999947 16.4883 1.00008 16.3559C1.00009 16.3438 1.00011 16.3317 1.00011 16.3196V4.99846C1.00011 4.98228 1.00008 4.966 1.00005 4.94965C0.999745 4.76006 0.999419 4.56018 1.04026 4.3729C1.15455 3.84885 1.50299 3.40636 1.98536 3.17211C2.15773 3.0884 2.35205 3.04166 2.53655 2.99729C2.55245 2.99346 2.56828 2.98965 2.58402 2.98584L2.61796 2.97762C3.3397 2.80278 3.74248 2.70521 4.14902 2.63913Z"
          className="fill-[#025EFF]"
        />
      </svg>
    ),
    calendar_busy: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75 1.5C7.16421 1.5 7.5 1.83579 7.5 2.25V3.5H12.5V2.25C12.5 1.83579 12.8358 1.5 13.25 1.5C13.6642 1.5 14 1.83579 14 2.25V3.5H16.25C17.7688 3.5 19 4.73122 19 6.25V9.25C19 9.66421 18.6642 10 18.25 10H2.5V16.75C2.5 17.4404 3.05964 18 3.75 18H8.75C9.16421 18 9.5 18.3358 9.5 18.75C9.5 19.1642 9.16421 19.5 8.75 19.5H3.75C2.23122 19.5 1 18.2688 1 16.75V6.25C1 4.73122 2.23122 3.5 3.75 3.5H6V2.25C6 1.83579 6.33579 1.5 6.75 1.5ZM6 5H3.75C3.05964 5 2.5 5.55964 2.5 6.25V8.5H17.5V6.25C17.5 5.55964 16.9404 5 16.25 5H14V5.75C14 6.16421 13.6642 6.5 13.25 6.5C12.8358 6.5 12.5 6.16421 12.5 5.75V5H7.5V5.75C7.5 6.16421 7.16421 6.5 6.75 6.5C6.33579 6.5 6 6.16421 6 5.75V5ZM12 16.25C12 15.8358 12.3358 15.5 12.75 15.5H19.25C19.6642 15.5 20 15.8358 20 16.25C20 16.6642 19.6642 17 19.25 17H12.75C12.3358 17 12 16.6642 12 16.25Z"
          className="fill-[#D20306]"
        />
      </svg>
    ),
    start_outline: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0928 3.02324C9.99905 2.97488 9.86181 3.00026 9.79335 3.14522L8.00799 6.92557C7.76215 7.44613 7.27807 7.82297 6.69953 7.91082L2.70736 8.51703C2.66367 8.52366 2.61758 8.54593 2.57857 8.58775C2.47149 8.70255 2.47467 8.89827 2.58316 9.00878L5.47192 11.9514C5.87611 12.3631 6.05323 12.9463 5.96057 13.5109L5.27863 17.6659C5.2674 17.7343 5.27853 17.8035 5.30766 17.8614C5.3787 18.0027 5.51526 18.0255 5.60897 17.974L9.17967 16.0123C9.69201 15.7308 10.3079 15.7308 10.8202 16.0123L14.3909 17.974C14.434 17.9977 14.48 18.0045 14.5234 17.9967C14.5864 17.9854 14.6553 17.9449 14.7056 17.8752C14.754 17.8081 14.7706 17.7347 14.7603 17.6681L14.0393 13.5109C13.9466 12.9463 14.1238 12.3631 14.5279 11.9514L17.4167 9.00878C17.4568 8.96792 17.4872 8.90957 17.4968 8.84084C17.5227 8.65465 17.3972 8.53293 17.2925 8.51703L13.3003 7.91082C12.7218 7.82297 12.2377 7.44613 11.9919 6.92557L10.2065 3.14522C10.1788 3.08657 10.1367 3.04586 10.0928 3.02324ZM8.437 2.50466C8.85086 1.62835 9.89685 1.23443 10.7804 1.6901C11.1257 1.86818 11.3985 2.15664 11.5629 2.50466L13.3482 6.28501C13.3898 6.37307 13.4613 6.41807 13.5255 6.42782L17.5177 7.03403C18.4915 7.1819 19.1133 8.10658 18.9825 9.04743C18.9296 9.42748 18.7578 9.78392 18.4871 10.0596L15.5984 13.0022C15.5379 13.0637 15.5029 13.162 15.5191 13.2656L16.2401 17.4229C16.4008 18.402 15.7151 19.307 14.788 19.4732C14.4037 19.542 14.0097 19.476 13.6686 19.2887L10.0979 17.3269C10.0354 17.2926 9.96447 17.2926 9.90194 17.3269L6.33123 19.2887C5.46031 19.7671 4.40376 19.4024 3.96767 18.5356C3.79485 18.192 3.7363 17.8015 3.79843 17.4229L4.48038 13.2679C4.49751 13.1635 4.4624 13.0642 4.40151 13.0022L1.51275 10.0596C0.840839 9.37517 0.828048 8.26534 1.48168 7.5646C1.74558 7.28168 2.09641 7.09261 2.48217 7.03403L6.47434 6.42782C6.53853 6.41807 6.61006 6.37307 6.65165 6.28501L8.437 2.50466Z"
          className="fill-[#F57C00]"
        />
      </svg>
    ),
    plus: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 7.19995L12 16.8M16.8 12L7.2 12"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        ,
      </svg>
    ),
    locksection: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M12.2857 7.16699H3.71429C2.76751 7.16699 2 7.91317 2 8.83364V13.8336C2 14.754 2.76751 15.5002 3.71429 15.5002H12.2857C13.2325 15.5002 14 14.754 14 13.8336V8.83364C14 7.91317 13.2325 7.16699 12.2857 7.16699Z"
          stroke="#A1A1A1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.00021 12.1666C8.4736 12.1666 8.85735 11.7936 8.85735 11.3333C8.85735 10.8731 8.4736 10.5 8.00021 10.5C7.52682 10.5 7.14307 10.8731 7.14307 11.3333C7.14307 11.7936 7.52682 12.1666 8.00021 12.1666Z"
          stroke="#A1A1A1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.57153 7.16658V3.83329C4.57153 2.94925 4.93276 2.10141 5.57574 1.4763C6.21872 0.851185 7.09079 0.5 8.0001 0.5C8.90942 0.5 9.78149 0.851185 10.4245 1.4763C11.0675 2.10141 11.4287 2.94925 11.4287 3.83329V7.16658"
          stroke="#A1A1A1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    calendar: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.09995 1.19995C8.59701 1.19995 8.99995 1.60289 8.99995 2.09995V3.59995H15V2.09995C15 1.60289 15.4029 1.19995 15.9 1.19995C16.397 1.19995 16.8 1.60289 16.8 2.09995V3.59995H19.5C21.3225 3.59995 22.7999 5.07741 22.7999 6.89995V19.5C22.7999 21.3225 21.3225 22.7999 19.5 22.7999H4.49995C2.67741 22.7999 1.19995 21.3225 1.19995 19.5V6.89995C1.19995 5.07741 2.67741 3.59995 4.49995 3.59995H7.19995V2.09995C7.19995 1.60289 7.60289 1.19995 8.09995 1.19995ZM7.19995 5.39995H4.49995C3.67152 5.39995 2.99995 6.07152 2.99995 6.89995V9.59995H21V6.89995C21 6.07152 20.3284 5.39995 19.5 5.39995H16.8V6.29995C16.8 6.79701 16.397 7.19995 15.9 7.19995C15.4029 7.19995 15 6.79701 15 6.29995V5.39995H8.99995V6.29995C8.99995 6.79701 8.59701 7.19995 8.09995 7.19995C7.60289 7.19995 7.19995 6.79701 7.19995 6.29995V5.39995ZM21 11.4H2.99995V19.5C2.99995 20.3284 3.67152 21 4.49995 21H19.5C20.3284 21 21 20.3284 21 19.5V11.4Z"
          className="fill-bw-14"
        />
      </svg>
    ),
    calendarStudent: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 21.4639C1.5 21.7622 1.61853 22.0484 1.8295 22.2594C2.04048 22.4703 2.32663 22.5889 2.625 22.5889H21.375C21.6734 22.5889 21.9595 22.4703 22.1705 22.2594C22.3815 22.0484 22.5 21.7622 22.5 21.4639V8.33887H1.5V21.4639ZM16.5 10.0264C16.5 9.97664 16.5198 9.92895 16.5549 9.89378C16.5901 9.85862 16.6378 9.83887 16.6875 9.83887H18.5625C18.6122 9.83887 18.6599 9.85862 18.6951 9.89378C18.7302 9.92895 18.75 9.97664 18.75 10.0264V11.9014C18.75 11.9511 18.7302 11.9988 18.6951 12.0339C18.6599 12.0691 18.6122 12.0889 18.5625 12.0889H16.6875C16.6378 12.0889 16.5901 12.0691 16.5549 12.0339C16.5198 11.9988 16.5 11.9511 16.5 11.9014V10.0264ZM16.5 13.7764C16.5 13.7266 16.5198 13.6789 16.5549 13.6438C16.5901 13.6086 16.6378 13.5889 16.6875 13.5889H18.5625C18.6122 13.5889 18.6599 13.6086 18.6951 13.6438C18.7302 13.6789 18.75 13.7266 18.75 13.7764V15.6514C18.75 15.7011 18.7302 15.7488 18.6951 15.7839C18.6599 15.8191 18.6122 15.8389 18.5625 15.8389H16.6875C16.6378 15.8389 16.5901 15.8191 16.5549 15.7839C16.5198 15.7488 16.5 15.7011 16.5 15.6514V13.7764ZM12.75 10.0264C12.75 9.97664 12.7698 9.92895 12.8049 9.89378C12.8401 9.85862 12.8878 9.83887 12.9375 9.83887H14.8125C14.8622 9.83887 14.9099 9.85862 14.9451 9.89378C14.9802 9.92895 15 9.97664 15 10.0264V11.9014C15 11.9511 14.9802 11.9988 14.9451 12.0339C14.9099 12.0691 14.8622 12.0889 14.8125 12.0889H12.9375C12.8878 12.0889 12.8401 12.0691 12.8049 12.0339C12.7698 11.9988 12.75 11.9511 12.75 11.9014V10.0264ZM12.75 13.7764C12.75 13.7266 12.7698 13.6789 12.8049 13.6438C12.8401 13.6086 12.8878 13.5889 12.9375 13.5889H14.8125C14.8622 13.5889 14.9099 13.6086 14.9451 13.6438C14.9802 13.6789 15 13.7266 15 13.7764V15.6514C15 15.7011 14.9802 15.7488 14.9451 15.7839C14.9099 15.8191 14.8622 15.8389 14.8125 15.8389H12.9375C12.8878 15.8389 12.8401 15.8191 12.8049 15.7839C12.7698 15.7488 12.75 15.7011 12.75 15.6514V13.7764ZM12.75 17.5264C12.75 17.4766 12.7698 17.4289 12.8049 17.3938C12.8401 17.3586 12.8878 17.3389 12.9375 17.3389H14.8125C14.8622 17.3389 14.9099 17.3586 14.9451 17.3938C14.9802 17.4289 15 17.4766 15 17.5264V19.4014C15 19.4511 14.9802 19.4988 14.9451 19.5339C14.9099 19.5691 14.8622 19.5889 14.8125 19.5889H12.9375C12.8878 19.5889 12.8401 19.5691 12.8049 19.5339C12.7698 19.4988 12.75 19.4511 12.75 19.4014V17.5264ZM9 13.7764C9 13.7266 9.01975 13.6789 9.05492 13.6438C9.09008 13.6086 9.13777 13.5889 9.1875 13.5889H11.0625C11.1122 13.5889 11.1599 13.6086 11.1951 13.6438C11.2302 13.6789 11.25 13.7266 11.25 13.7764V15.6514C11.25 15.7011 11.2302 15.7488 11.1951 15.7839C11.1599 15.8191 11.1122 15.8389 11.0625 15.8389H9.1875C9.13777 15.8389 9.09008 15.8191 9.05492 15.7839C9.01975 15.7488 9 15.7011 9 15.6514V13.7764ZM9 17.5264C9 17.4766 9.01975 17.4289 9.05492 17.3938C9.09008 17.3586 9.13777 17.3389 9.1875 17.3389H11.0625C11.1122 17.3389 11.1599 17.3586 11.1951 17.3938C11.2302 17.4289 11.25 17.4766 11.25 17.5264V19.4014C11.25 19.4511 11.2302 19.4988 11.1951 19.5339C11.1599 19.5691 11.1122 19.5889 11.0625 19.5889H9.1875C9.13777 19.5889 9.09008 19.5691 9.05492 19.5339C9.01975 19.4988 9 19.4511 9 19.4014V17.5264ZM5.25 13.7764C5.25 13.7266 5.26975 13.6789 5.30492 13.6438C5.34008 13.6086 5.38777 13.5889 5.4375 13.5889H7.3125C7.36223 13.5889 7.40992 13.6086 7.44508 13.6438C7.48025 13.6789 7.5 13.7266 7.5 13.7764V15.6514C7.5 15.7011 7.48025 15.7488 7.44508 15.7839C7.40992 15.8191 7.36223 15.8389 7.3125 15.8389H5.4375C5.38777 15.8389 5.34008 15.8191 5.30492 15.7839C5.26975 15.7488 5.25 15.7011 5.25 15.6514V13.7764ZM5.25 17.5264C5.25 17.4766 5.26975 17.4289 5.30492 17.3938C5.34008 17.3586 5.38777 17.3389 5.4375 17.3389H7.3125C7.36223 17.3389 7.40992 17.3586 7.44508 17.3938C7.48025 17.4289 7.5 17.4766 7.5 17.5264V19.4014C7.5 19.4511 7.48025 19.4988 7.44508 19.5339C7.40992 19.5691 7.36223 19.5889 7.3125 19.5889H5.4375C5.38777 19.5889 5.34008 19.5691 5.30492 19.5339C5.26975 19.4988 5.25 19.4511 5.25 19.4014V17.5264Z"
          fill="#FFB800"
        />
        <path
          d="M21.375 3.08887H18.7537V1.58887H16.5037V3.08887H7.49625V1.58887H5.24625V3.08887H2.625C2.47783 3.08763 2.33186 3.11553 2.19551 3.17095C2.05917 3.22637 1.93514 3.30823 1.83057 3.4118C1.72599 3.51537 1.64295 3.63861 1.58622 3.77441C1.52948 3.91022 1.50018 4.05591 1.5 4.20309V6.83887H22.5V4.20309C22.4998 4.05591 22.4705 3.91022 22.4138 3.77441C22.357 3.63861 22.274 3.51537 22.1694 3.4118C22.0649 3.30823 21.9408 3.22637 21.8045 3.17095C21.6681 3.11553 21.5222 3.08763 21.375 3.08887Z"
          fill="#FFB800"
        />
      </svg>
    ),
    arrowUp: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0002 6.7996C12.1318 6.7989 12.2623 6.8241 12.3841 6.8738C12.5059 6.9236 12.6167 6.9969 12.7102 7.0896L18.7102 13.0896C18.8034 13.1829 18.8774 13.2935 18.9278 13.4154C18.9783 13.5372 19.0043 13.6678 19.0043 13.7996C19.0043 14.0659 18.8985 14.3213 18.7102 14.5096C18.5219 14.6979 18.2665 14.8037 18.0002 14.8037C17.7339 14.8037 17.4785 14.6979 17.2902 14.5096L12.0002 9.2196L6.71019 14.5096C6.61695 14.6029 6.5063 14.6768 6.38444 14.7273C6.26258 14.7777 6.13203 14.8037 6.00019 14.8037C5.86835 14.8037 5.7378 14.7777 5.61594 14.7273C5.49408 14.6768 5.38343 14.6029 5.29019 14.5096C5.19695 14.4164 5.12299 14.3057 5.07253 14.1839C5.02207 14.062 4.99609 13.9315 4.99609 13.7996C4.99609 13.6678 5.02207 13.5372 5.07253 13.4154C5.12299 13.2935 5.19695 13.1829 5.29019 13.0896L11.2902 7.0896C11.3836 6.9969 11.4944 6.9236 11.6163 6.8738C11.7381 6.8241 11.8686 6.7989 12.0002 6.7996Z"
          fill="#A1A1A1"
        />
      </svg>
    ),
    arrowDown: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0002 17.1999C11.8686 17.2007 11.7381 17.1754 11.6163 17.1257C11.4944 17.0759 11.3836 17.0026 11.2902 16.9099L5.29019 10.9099C5.19695 10.8167 5.12299 10.706 5.07253 10.5841C5.02207 10.4623 4.99609 10.3318 4.99609 10.1999C4.99609 9.93359 5.10188 9.6782 5.29019 9.48989C5.47849 9.30159 5.73388 9.1958 6.00019 9.1958C6.26649 9.1958 6.52188 9.30159 6.71019 9.48989L12.0002 14.7799L17.2902 9.48989C17.3834 9.39665 17.4941 9.32269 17.6159 9.27223C17.7378 9.22177 17.8683 9.1958 18.0002 9.1958C18.132 9.1958 18.2626 9.22177 18.3844 9.27223C18.5063 9.32269 18.6169 9.39665 18.7102 9.48989C18.8034 9.58313 18.8774 9.69382 18.9278 9.81564C18.9783 9.93747 19.0043 10.068 19.0043 10.1999C19.0043 10.3318 18.9783 10.4623 18.9278 10.5841C18.8774 10.706 18.8034 10.8167 18.7102 10.9099L12.7102 16.9099C12.6167 17.0026 12.5059 17.0759 12.3841 17.1257C12.2623 17.1754 12.1318 17.2007 12.0002 17.1999Z"
          fill="#A1A1A1"
        />
      </svg>
    ),
    arrowDownFull: (
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 8C4.60655 8 4.23607 7.80241 4 7.46667L0.250007 2.13333C-0.0340716 1.72931 -0.0797668 1.18876 0.131973 0.737049C0.343713 0.285337 0.776541 0 1.25001 0H8.74999C9.22346 0 9.65629 0.285337 9.86803 0.737049C10.0798 1.18876 10.0341 1.72931 9.74999 2.13333L6 7.46667C5.76393 7.80241 5.39345 8 5 8Z"
          fill="#FFB800"
        />
      </svg>
    ),
    arrowRightFull: (
      <svg
        width="8"
        height="10"
        viewBox="0 0 8 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.737049 0.131973C1.18876 -0.0797666 1.72931 -0.0340718 2.13333 0.250007L7.46667 4C7.80241 4.23607 8 4.60655 8 5C8 5.39345 7.80241 5.76393 7.46667 6L2.13333 9.74999C1.72931 10.0341 1.18876 10.0798 0.737049 9.86803C0.285336 9.65629 0 9.22346 0 8.74999V1.25001C0 0.776541 0.285336 0.343713 0.737049 0.131973Z"
          fill="#A1A1A1"
        />
      </svg>
    ),
    warningIcon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.2"
          d="M8.00016 14.6663C11.6821 14.6663 14.6668 11.6816 14.6668 7.99967C14.6668 4.31778 11.6821 1.33301 8.00016 1.33301C4.31826 1.33301 1.3335 4.31778 1.3335 7.99967C1.3335 11.6816 4.31826 14.6663 8.00016 14.6663Z"
          fill="#F01919"
        />
        <path
          d="M8.00016 7.06641C8.17697 7.06641 8.34654 7.13664 8.47157 7.26167C8.59659 7.38669 8.66683 7.55626 8.66683 7.73307V10.8397C8.66683 11.0166 8.59659 11.1861 8.47157 11.3111C8.34654 11.4362 8.17697 11.5064 8.00016 11.5064C7.82335 11.5064 7.65378 11.4362 7.52876 11.3111C7.40373 11.1861 7.3335 11.0166 7.3335 10.8397V7.73307C7.3335 7.55626 7.40373 7.38669 7.52876 7.26167C7.65378 7.13664 7.82335 7.06641 8.00016 7.06641Z"
          fill="#F01919"
        />
        <path
          d="M8.00033 6.15983C8.46056 6.15983 8.83366 5.78673 8.83366 5.3265C8.83366 4.86626 8.46056 4.49316 8.00033 4.49316C7.54009 4.49316 7.16699 4.86626 7.16699 5.3265C7.16699 5.78673 7.54009 6.15983 8.00033 6.15983Z"
          fill="#F01919"
        />
      </svg>
    ),
  }

  return <div>{SAPP_ICONS[icon]}</div>
}

export default SappIcon
